import { CurrencyDisplay } from "commonComponents/financial/CurrencyDisplay/CurrencyDisplay";
import { CurrencyFooterCell } from "commonComponents/utilities/Grid/common/columnImplementations/columnCurrency";
import { type IGridCellRenderProps } from "commonComponents/utilities/Grid/Grid.types";
import {
    GridColumnType,
    type IClientGridColumn,
} from "commonComponents/utilities/Grid/GridContainer.types";

export interface IBillAmountCellValue {
    value?: number | null;
    scale: number;
    isPartiallyPaid: boolean;
}

const BillAmountCell = ({
    cellValue,
    field,
}: IGridCellRenderProps<IBillAmountCellValue | undefined>) => {
    if (!cellValue || cellValue.value == null) {
        return null;
    }

    return (
        <div data-testid={field.full} className="flex flex-col items-end">
            <CurrencyDisplay value={cellValue.value} decimalScale={cellValue.scale} />
            {cellValue.isPartiallyPaid && (
                <span className="text-xs text-fg-tertiary">Partially paid</span>
            )}
        </div>
    );
};

export const columnBillAmount: IClientGridColumn<IBillAmountCellValue | undefined> = {
    columnType: GridColumnType.billAmount,
    Cell: BillAmountCell,
    FooterCell: (props) => <CurrencyFooterCell {...props} shouldUseAccountingMode={false} />,
};
